import { button } from "../../design/components.js";
import type { LabelAction } from "@beacon/client-core";

export interface TransparencyCtx {
  t: (k: string, p?: Record<string, string | number>) => string;
  /** Actions against this identity, from LabelFold.actionsAgainst(myDid). */
  actions: LabelAction[];
  onAppeal: (action: LabelAction) => void;
}

/** "Your flags & appeals" (GUI §5; moderation spec §7 transparency surface).
 *  Pull-only, localized, neutral framing, emphasizes reversibility + appeal. */
export function flagsAndAppeals(ctx: TransparencyCtx): HTMLElement {
  const t = ctx.t;
  const root = document.createElement("section");
  root.className = "you-card transparency";
  root.setAttribute("data-card", "transparency");
  const title = document.createElement("div");
  title.className = "bx-microlabel";
  title.textContent = t("you.flags.title");
  root.append(title);

  if (ctx.actions.length === 0) {
    const empty = document.createElement("p");
    empty.className = "bx-body";
    empty.textContent = t("you.flags.empty");
    root.append(empty);
    return root;
  }

  for (const a of ctx.actions) {
    const card = document.createElement("div");
    card.className = "transparency__action";
    card.setAttribute("data-action-card", a.subject);
    const label = document.createElement("p");
    label.className = "bx-body";
    label.textContent = `${t("you.flags.actionLabel")} · ${t("you.flags.weight")}`;
    const reversible = document.createElement("p");
    reversible.className = "bx-microlabel";
    reversible.textContent = t("you.flags.reversible");
    card.append(label, reversible);
    if (a.expiresAt) {
      const exp = document.createElement("p");
      exp.className = "bx-microlabel";
      exp.textContent = t("you.flags.expires", { date: a.expiresAt });
      card.append(exp);
    }
    const appeal = button({ label: t("you.flags.appeal"), variant: "secondary", onClick: () => ctx.onAppeal(a) });
    appeal.setAttribute("data-action", "appeal");
    card.append(appeal);
    root.append(card);
  }
  return root;
}
